/**
 * 描述：表单校验规则
 * 作者：bai.zhiming
 * 日期：2017-6-16
 */
angular.module("validationRuleModule", [])
	.config(["$validationProvider", function($validationProvider) {
		var expression = {
			ip: /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
			sensitiveWords: function(value) {
				var flag = true;
				angular.forEach(value.split("\n"), function(data, index, array) {
					var reg = /^([a-zA-Z0-9\u4e00-\u9fa5]{1,50}),([^,< > / \ ' "]{0,50}),([12]{0,1})$|^([a-zA-Z0-9\u4e00-\u9fa5]{1,50}),([^,< > / \ ' "]{0,50})$|^([a-zA-Z0-9\u4e00-\u9fa5]{1,50}),([^,< > / \ ' "]{0,50}),$|^([a-zA-Z0-9\u4e00-\u9fa5]{1,50})$/;
					data.match(reg) ? "" : flag = false;
				});
				return flag;
			},
			userName: function(value) {
				var flag = true;
				if(value == 'admin' || value == 'system') {
					flag = false;
				}
				return flag;
			},
			userNameChar: /^[\u4E00-\u9FA5A-Za-z][\u4E00-\u9FA5A-Za-z0-9_.\-]+$/,
			/*sperChnlIds: /^((([0-9]+,)*[0-9]+)|([0-9]*))$/,*/
			sperChnlIds: function(value) {
				if(!value) return true;
				var sperChnlIds_REGEXP = /^((([0-9]+,)*[0-9]+)|([0-9]*))$/;
				return sperChnlIds_REGEXP.test(value);
			},
			uniqueTime: function(value) {
				return value.length < 5;
			},
			posInt: function(value) {
				if(!value) return true;
				var posInt_REGEXP = /^[1-9][0-9]*$/;
				return posInt_REGEXP.test(value);
			},
			maxindex: function(value, scope, element, attrs, param) {
				if(!value) return true;
				return parseInt(value) <= param;
			},
			minindex: function(value, scope, element, attrs, param) {
				if(!value) return true;
				return parseInt(value) >= param;
			},
			isDecimal: function(value) {
				return !isNaN(Number(value));
			},
			limitDecimal: function(value) {
				if(value == "") {
					return true;
				}
				var reg = /^\d+(\.\d{1,2})?$/;
				return reg.test(value);
			},
			comparescore: function(value, scope, element, attrs, param) {
				return parseInt(attrs.name) >= value;
			},
			maxwordlength: function(value, scope, element, attrs, param) {
				if(!value) return true;
				var newVal = value.replace(/\<\/?[A-Za-z]+(.*?)\>/g, "");
				var len = 0;
				for(var i = 0; i < newVal.length; i++) {
					var data = newVal[i];
					if(data.match(/[\u0000-\u00ff]/g)) len += 0.5;
					else if(data.match(/[\u4e00-\u9fa5]|[！￥……（）——【】：“‘？《》？、·。，]/g)) len++;
					else if(data.match(/[\uff00-\uffff]/g)) len++;
					else if(data.match(/ /g)) len += 0.5;
					else if(data.match(/　/g)) len++;
				}
				return len <= param;
			},
			maxnumberlength: function(value) {
				if(!value) return true;
				var num = value.toString().split(".");
				return num[0].length < 13;
			},
			maxnumberlengthto10: function(value) {
				if(!value) return true;
				var num = value.toString().split(".");
				return num[0].length < 11;
			},
			postIntForNum: function(value) {
				if(!value) return true;
				var posInt_REGEXP = /^[0-9][0-9]*$/;
				return posInt_REGEXP.test(value);
			},
			requiredExcept0: function(value) {
				if(value === 0 || value === '0') return true;
				return !!value;
			},
			bankCard: function(value) {
				if(value){
					return /^(\d{16}|\d{17}|\d{18}|\d{19})$/.test(value);
				}
				return true;
			},
			orgCode: function(value) {
				if(value){
					return /^[a-z0-9A-Z]{18}$/.test(value);
				}
				return true;
			},
			ruoPwd: function(value){
				var modes = 0;
                if (/\d/.test(value)) modes++; //数字
                if (/^[a-z]/i.test(value)) modes++; //英文字母
                if (/\W|_/.test(value)) modes++; //特殊字符
                if(modes <= 1){
                	return false;
                }
                return true;
			},
			isChina:function(value){
				if(/^[0-9a-zA-Z]+$/.test(value)) return true;
			    return false ;
			},
			mobilephoneNew: function (value) {
				if (!value) return true;
				var MOBILEPHONE_REGEXP = /^(1[2-9][0-9])\d{8}$/;
				return MOBILEPHONE_REGEXP.test(value);
			}

		};
		var validMsg = {
			ip: {
				error: 'IP格式不正确',
				success: '正确'
			},
			sensitiveWords: {
				error: '敏感词格式错误',
				success: '正确'
			},
			userName: {
				error: "用户名不能使用系统保留账号",
				success: "正确"
			},
			userNameChar: {
				error: "不符合填写规则",
				success: "正确"
			},
			sperChnlIds: {
				error: "不符合填写规则",
				success: "正确"
			},
			uniqueTime: {
				error: "排重时间不能大于5位数",
				success: "正确"
			},
			posInt: {
				error: '只能填写正整数！',
				success: '正确'
			},
			maxindex: {
				error: "超过最大序号数",
				success: "正确"
			},
			minindex: {
				error: "小于最小序号数",
				success: "正确"
			},
			isDecimal: {
				error: "请输入正确的数字",
				success: "正确"
			},
			limitDecimal: {
				error: "只能输入0和正数且只保留小数点后两位",
				success: "正确"
			},
			comparescore: {
				error: "得分不能超过规定分值",
				success: "正确"
			},
			maxwordlength: {
				error: "长度不能超过50个字符",
				success: "正确"
			},
			maxnumberlength: {
				error: "数字长度不能超过12位",
				success: "正确"
			},
			maxnumberlengthto10: {
				error: "数字长度不能超过10位",
				success: "正确"
			},
			postIntForNum: {
				error: "请输入不小于0的数字",
				success: "正确"
			},
			requiredExcept0: {
				error: "这是必填项！",
				success: "正确"
			},
			bankCard: {
				error: "请输入有效的银行卡号",
				success: "正确"
			},
			orgCode: {
				error: '请输入正确的统一社会信用代码',
				success: '正确'
			},
			ruoPwd:{
				error: '必须包含字母、数字、符号中至少2种',
				success: '正确'
			},
			isChina:{
				error:'只能输入英文字母、数字',
				success:'正确',
			},
			mobilephoneNew: {
				error: '手机号码错误',
				success: '正确'
			},
		};
		$validationProvider.setExpression(expression) // set expression
			.setDefaultMsg(validMsg); // set valid message
	}]);
